<div class="logo-big">
  <img [src]="logo" />
</div>
<div class="login-container">
  <h3 class="text-center">Log in to CMS</h3>
  <div class="form-container">
    <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <div class="control">
        <label for="login">Username</label>
        <lib-cm-input
          placeholder=""
          formControlName="login"
          id="atqa-login"
          [titlecase]="false"
          [clearable]="true"
        ></lib-cm-input>
      </div>
      <div class="link margin-bottom">
        <span class="forgot-username" (click)="forgotUsername()">Forgot username</span>
      </div>
      <div class="control password-input">
        <label for="password">Password</label>
        <lib-cm-input
          #passwordControl
          placeholder=""
          [type]="passwordVisibility ? 'text' : 'password'"
          formControlName="password"
          id="atqa-password"
          [titlecase]="false"
        ></lib-cm-input>
        <div class="password-visibility" (click)="onChangePasswordVisibility()">
          @if (passwordVisibility) {
          <span class="material-icons"> visibility </span>
          } @if (!passwordVisibility) {
          <span class="material-icons"> visibility_off </span>
          }
        </div>
      </div>
      <div class="link margin-bottom">
        <a routerLink="/password-email">Forgot password</a>
      </div>
      @if (showCodeField) {
      <div class="control">
        @if (errorType === authTypeValue.EMAIL) {
        <label for="pin">PIN</label>
        } @else {
        <div class="code-label-row">
          <label for="pin">Authenticator Code</label>
          <span
            class="code-info-icon"
            role="button"
            tabindex="0"
            aria-label="About authenticator code"
            [tooltip]="authenticatorCodeInfo"
            contentType="template"
            placement="top"
            tooltipClass="code-info-message"
            >i</span
          >
        </div>
        }
        <lib-cm-input
          #pinControl
          [placeholder]="errorType === authTypeValue.EMAIL ? '' : 'Enter 6-digit code'"
          formControlName="pin"
          id="atqa-pin"
          [titlecase]="false"
        ></lib-cm-input>
      </div>
      @if (errorType !== authTypeValue.EMAIL) {
      <div class="link code-links-row">
        <a routerLink="/mfa-email">Can’t use authenticator</a>
        <a class="code-info-link" (click)="openAuthenticatorCodeInfo()"
          >What is an authenticator code?</a
        >
      </div>
      } }
      <div class="remember-me margin-bottom">
        <lib-cm-checkbox
          label="Remember me"
          formControlName="rememberMe"
          id="atqa-remember-me"
        ></lib-cm-checkbox>
        <span
          [tooltip]="rememberMeInfo"
          contentType="template"
          placement="right"
          class="material-icons remember-me-info-icon"
          tooltipClass="remember-me-info-message"
        >
          help
        </span>
      </div>

      <button type="submit" class="login-btn" [disabled]="loginBtnDisabled" id="atqa-login-btn">
        <div class="spinner-rect-container" [class.show]="loading">
          <spinner-rect color="white"></spinner-rect>
        </div>
        <div class="title" [class.not-visible]="loading">Log in</div>
      </button>
      @if (error) {
      <div class="error-container">
        @if (status === 401) {
        <span class="error">
          <i class="material-icons error-icon">report_problem</i>
          <span class="error-message">
            {{ error }}
          </span>
        </span>
        } @if (status !== 401) {
        <span class="error">
          <span class="error-message">
            {{ 'ERROR: ' + error }}
          </span>
        </span>
        }
      </div>
      }
    </form>
  </div>
</div>

<ng-template #authenticatorCodeInfo>
  <span
    >Enter the 6-digit code from your authenticator app (e.g., Google Authenticator or Microsoft
    Authenticator) or browser extension, such as Authenticator for Chrome, Edge or Firefox. The code
    refreshes every 30 seconds.</span
  >
</ng-template>

<ng-template #rememberMeInfo>
  <span
    >Remember me keeps you logged in on this browser for 30 days.<br />
    If you use a different browser or device, you will need to log in again.</span
  >
</ng-template>
